var render = function () {
  var _vm$content, _vm$content$exportDat, _vm$content$exportDat2, _vm$content2, _vm$content2$importDa, _vm$content3, _vm$content3$exportDa, _vm$content4, _vm$content4$exportDa, _vm$content5, _vm$content5$importDa;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('v-app-bar', {
    staticClass: "subheader-app-bar",
    staticStyle: {
      "margin-top": "49px",
      "z-index": "2"
    },
    attrs: {
      "app": "",
      "color": "white",
      "dense": "",
      "flat": ""
    }
  }, [_vm.content.enableBackButton ? _c('go-back-button', {
    staticStyle: {
      "margin-right": "20px"
    }
  }) : _vm._e(), _c('v-toolbar-title', {
    staticClass: "create-title"
  }, [_c('h5', [_vm._v(" " + _vm._s(_vm.content.pageTitle) + " ")])]), _vm._l(_vm.content.commands, function (item, index) {
    return _c('div', {
      key: index
    }, [_c('v-btn', {
      staticClass: "create-button",
      attrs: {
        "text": "",
        "color": "primary"
      }
    }, [_c('router-link', {
      staticClass: "create-link",
      attrs: {
        "to": {
          name: item.link
        }
      }
    }, [_c('h4', [_c('v-icon', [_vm._v(_vm._s(item.icon))]), _vm._v(" " + _vm._s(item.buttonName) + " ")], 1)])], 1)], 1);
  }), [_c('v-list-item', [(_vm$content = _vm.content) !== null && _vm$content !== void 0 && (_vm$content$exportDat = _vm$content.exportData) !== null && _vm$content$exportDat !== void 0 && _vm$content$exportDat.active ? _c('v-btn', {
    staticClass: "ml-auto",
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.onClickShowExport();
      }
    }
  }, [_c('h4', [_c('v-icon', [_vm._v(_vm._s((_vm$content$exportDat2 = _vm.content.exportData) === null || _vm$content$exportDat2 === void 0 ? void 0 : _vm$content$exportDat2.icon))]), _vm._v(" " + _vm._s(_vm.content.exportData.buttonName) + " ")], 1)]) : _vm._e(), (_vm$content2 = _vm.content) !== null && _vm$content2 !== void 0 && (_vm$content2$importDa = _vm$content2.importData) !== null && _vm$content2$importDa !== void 0 && _vm$content2$importDa.active ? _c('v-btn', {
    class: !((_vm$content3 = _vm.content) !== null && _vm$content3 !== void 0 && (_vm$content3$exportDa = _vm$content3.exportData) !== null && _vm$content3$exportDa !== void 0 && _vm$content3$exportDa.active) && 'ml-auto',
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.onClickShowImport();
      }
    }
  }, [_c('h4', [_c('v-icon', [_vm._v(_vm._s(_vm.content.importData.icon))]), _vm._v(" " + _vm._s(_vm.content.importData.buttonName) + " ")], 1)]) : _vm._e()], 1)]], 2), [(_vm$content4 = _vm.content) !== null && _vm$content4 !== void 0 && (_vm$content4$exportDa = _vm$content4.exportData) !== null && _vm$content4$exportDa !== void 0 && _vm$content4$exportDa.active ? _c('side-bar-export', {
    attrs: {
      "exportData": _vm.content.exportData,
      "title": _vm.content.exportData.title
    }
  }) : _vm._e(), (_vm$content5 = _vm.content) !== null && _vm$content5 !== void 0 && (_vm$content5$importDa = _vm$content5.importData) !== null && _vm$content5$importDa !== void 0 && _vm$content5$importDa.active ? _c('side-bar-import', {
    attrs: {
      "importData": _vm.content.importData,
      "title": _vm.content.importData.title
    }
  }) : _vm._e()]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }